import { getWorkorderStatus } from "../../../aplUtils/statusConditionEnumHelper";
import { ColumnFilterOrDisplayType, ConfigColumns2 } from "../../../types/configColumns2";
import { Culture } from "../../../types/culture";

const workorderManagementOperationsPaneColumns = (culture: Culture, jobIn: boolean): ConfigColumns2[] => {
    let colums = [
        { data: "operationId", visible: false, width: "0%", title: "operationId" },
        { data: "linePlantCode", className: "nowrap", width: "33%", title: "workCenter" },
        { data: "lineDescription", className: "nowrap", width: "33%", title: "line" },
        {
            data: "worksOrderStatusIdConsumption",
            className: "nowrap",
            width: "33%",
            title: "consumptionStatus",
            render: function (data: any, type: ColumnFilterOrDisplayType | undefined) {
                return getWorkorderStatus(data.worksOrderStatusIdConsumption, culture);
            }
        },
        {
            data: "worksOrderStatusIdLabelling",
            className: "nowrap",
            width: "33%",
            title: "labellingStatus",
            render: function (data: any, type: ColumnFilterOrDisplayType | undefined) {
                return getWorkorderStatus(data.worksOrderStatusIdLabelling, culture);
            }
        }
    ];
    colums.push(
        jobIn
            ? { data: "inLineDescription", className: "nowrap", width: "33%", title: "lineIn" }
            : {
                  data: "inLineDescription",
                  className: "nowrap",
                  width: "100%",
                  title: "",
                  render: function (data: any, type: ColumnFilterOrDisplayType | undefined) {
                      return " ";
                  }
              }
    );
    return colums;
};

export { workorderManagementOperationsPaneColumns };
